"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableRegionCourses = void 0;
const dayjs = require("dayjs");
const isCourseClosed_1 = require("./isCourseClosed");
const hasValidNumberOfGolfers_1 = require("./hasValidNumberOfGolfers");
const getAvailableRegionCourses = (courses, formData) => {
    return courses.filter((course) => {
        const valid_golfers = (0, hasValidNumberOfGolfers_1.hasValidNumberOfGolfers)(formData?.trip?.start_date || "", dayjs(formData?.trip?.start_date)
            .add(formData?.trip?.duration_days_nights || 0, "day")
            .format("YYYY-MM-DD"), (formData?.trip?.number_of_golfers || 0) +
            formData?.trip?.pga_pros?.count, course?.golf_contracts || []);
        return (valid_golfers &&
            !(0, isCourseClosed_1.isCourseClosed)(course?.course_closures || [], formData?.trip?.start_date || "", dayjs(formData?.trip?.start_date)
                .add(formData?.trip?.duration_days_nights || 0, "day")
                .format("YYYY-MM-DD"))?.closed);
    });
};
exports.getAvailableRegionCourses = getAvailableRegionCourses;
